import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useQuoteModal } from '../../contexts/QuoteModalContext';
import { TEE_DESIGNS as TEES } from '../../mock';



export default function MarqueeCTA() {
  const { openModal } = useQuoteModal();
  const row = [...TEES, ...TEES];
  return (
    <section className="relative bg-[#00b8ff] py-10 md:py-14 overflow-hidden">
      <div className="flex items-center gap-10 md:gap-14 animate-marquee-reverse whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <img
            key={`${t.name}-${i}`}
            src={t.src}
            alt={t.name}
            title={t.name}
            className="h-32 sm:h-40 md:h-52 w-auto object-contain flex-shrink-0"
            loading={i < 3 ? 'eager' : 'lazy'}
            decoding="async"
            fetchpriority={i === 0 ? 'high' : 'auto'}
          />
        ))}
      </div>
      <div className="text-center mt-8">
        <button
          type="button"
          onClick={openModal}
          className="inline-flex items-center gap-2 bg-black text-[#f4efe6] rounded-full px-7 py-3.5 font-semibold text-[15px] hover:bg-[#0a0a0a] transition-colors duration-200 group"
        >
          Get Started
          <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
        </button>
      </div>
    </section>
  );
}
